<div class="desafions-loading" *ngIf="carregandoDesafios">
  <ngx-skeleton-loader count="4" [theme]="{
      width: '85px',
      height: '85px',
      'border-radius': '200px',
      'margin-right': '16px'
    }"></ngx-skeleton-loader>
</div>

<div class="desafios" *ngIf="!carregandoDesafios">
  <carousel class="desafios__carousel" [arrows]="false" style="z-index: 1" [cellsToShow]="4.2"
    *ngIf="regDesafios.length > 0">
    <div class="carousel-cell" *ngFor="let desafio of regDesafios" (click)="desafio.circleProgress.onClick()">
      <app-circle-progress [fieldInput]="desafio"></app-circle-progress>
    </div>
  </carousel>
  <div class="sem_desafios" *ngIf="regDesafios.length === 0">
    <dynamic-form [fields]="regConfigSemDesafios"></dynamic-form>
  </div>

  <div class="saiba_mais_container" *ngIf="field.desafio.exibirSaibaMais">
    <button class="saiba_mais__button cs_botao" [routerLink]="['/missoes']">
      saiba mais
    </button>
  </div>
</div>